import { useState } from 'react'

export type ActionableState<ValueType> = {
  value: ValueType | null
  setValue: (newValue?: ValueType) => void
}

export const useActionableState = <ValueType>(initialValue?: ValueType): ActionableState<ValueType> => {
  // @ts-expect-error TS(2345) FIXME: Argument of type 'ValueType | undefined' is not as... Remove this comment to see the full error message
  const [value, setValue] = useState<ValueType>(initialValue)

  return {
    value,
    // @ts-expect-error TS(2322) FIXME: Type 'Dispatch<SetStateAction<ValueType>>' is not ... Remove this comment to see the full error message
    setValue,
  }
}
